// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 21"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.3263 0.903809H20.6998L13.3297 9.3273L22 20.7898H15.2112L9.89403 13.8378L3.80995 20.7898H0.434432L8.31743 11.7799L0 0.903809H6.96111L11.7674 7.25814L17.3263 0.903809ZM16.1423 18.7706H18.0116L5.94539 2.81694H3.93946L16.1423 18.7706Z"
    />
  </svg>
);
const IconSocialX = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconSocialX;
